const useInvoiceInfoPrivate = () => {
  // types for which private info should be masked
  const MASK_TYPES = ['seller', 'sales', 'public'];

  const formatInfoPrivate = (information, type) => {
    if (information && MASK_TYPES.includes(type)) {
      const length = information.length;
      const obfuscateLength = Math.ceil(length * 0.7);
      const visiblePart = information.slice(obfuscateLength);
      // mask the first part of the information
      return '*'.repeat(obfuscateLength) + visiblePart;
    }
    return information;
  };
  return { formatInfoPrivate };
};

export default useInvoiceInfoPrivate;
